import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationMessage } from '../services/model/notification-message.model';
import { DialogType } from '../services/model/dialog-type.enum';
import { UserService } from './user.service';
import { CascadeDealer } from './model/cascade-dealer.model';
import { DealerInfo } from './model/dealer-info.model';
import { ReportModel } from '../reports/model/report-option.model';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  public maxCount: number = 1;
  public showDialog: BehaviorSubject<NotificationMessage> =
    new BehaviorSubject<NotificationMessage>(
      new NotificationMessage(DialogType.notSet, '', [])
    );

  public yearList: Object[] = [];
  public billTos?: CascadeDealer[] = [];

  public dealerListForReports: DealerInfo[] = [];

  public reportConfigs: ReportModel[] = [];

  constructor(private readonly _user: UserService) {
    this.loadYearList();
  }

  public getCommissionCodeForAccount(accountNumber: number): number {
    let commissionCode: number | undefined = -999999;
    if (this._user.userProfile.isDealer || this._user.userProfile.isEmployee) {
      const searchResult = this.billTos?.find(
        (f) => f.billToAddress?.accountNumber == accountNumber
      );
      if (searchResult !== undefined) {
        commissionCode = searchResult.commissionCode1!;
      } else {
        this.billTos?.forEach((billTo) => {
          const shipToDealer = billTo.shipToAddresses?.find(
            (f) => f.accountNumber == accountNumber
          );
          if (shipToDealer !== undefined || shipToDealer !== null) {
            commissionCode = billTo.accountNumber;
          }
        });
      }

      if (commissionCode == undefined || commissionCode == null) {
        throw Error(
          `Unable to find commission code for ${accountNumber}.\n Please contact Dealer Service for further assistance.`
        );
      }
      return commissionCode!;
    } else if (this._user.userProfile.isSalesRep) {
      if (
        this._user.userProfile.commissionCode !== undefined ||
        this._user.userProfile.commissionCode !== null
      ) {
        commissionCode = this._user.userProfile.commissionCode;
      }
    }
    if (commissionCode == -999999) {
      throw Error(
        'Commission Code is required.\n Please contact Dealer Services for further assistance'
      );
    } else {
      return commissionCode!;
    }
  }

  public isNumber(text?: string): boolean {
    let isaNumber: boolean = false;
    try {
      if (text != undefined || text != null) {
        for (let index = 0; index < text?.length; index++) {
          const charCode = text.charCodeAt(index);
          if (charCode >= 48 && charCode <= 57) {
            isaNumber = true;
          } else {
            isaNumber = false;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
    return isaNumber;
  }

  public generateGuid(): string {
    let guid: string = '';
    try {
      guid = crypto.randomUUID();
    } catch (error) {
      console.error('generateGuid()', error);
    }
    return guid;
  }

  private loadYearList(): void {
    let date: Date = new Date();
    this.yearList.push({ year: date.getFullYear() });
    for (let index = 1; index < 6; index++) {
      this.yearList.push({ year: date.getFullYear() - index });
    }
  }

  public getISO8601Date(date: Date): string {
    // yyyy-mm-dd
    const d = this.validDateFormat(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private validDateFormat(date: Date): Date {
    try {
      if (date.toString().includes('T')) {
        return new Date(date.toString().split('T')[0]);
      } else {
        return date;
      }
    } catch (error) {
      console.error('validDateFormat()', error);
      return date;
    }
  }

  public isNullOrUndefined(property: any, value: any): any {
    if (property === null || value === undefined) {
      throw new Error(`Unable to find ${property}`);
    } else {
      return value;
    }
  }

  public isObjectEmpty(obj: Object): boolean {
    try {
      return obj && Object.keys(obj)?.length === 0;
    } catch (error) {
      console.error('isObjectEmpty()', error);
      return false;
    }
  }
}
